import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import plateBg from '../../assets/images/plate_classic_bg.png';

const StyledContainer = styled.div`
	position: relative;
	width: 260px;
	height: 70px;
	background-color: #f4f4f4;
	border-radius: 10px;
	background-image: url(${plateBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledStroke = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	bottom: 2px;
	right: 2px;
	opacity: 0.5;
	border: 1px solid #000000;
	border-radius: 9px;
`;

const StyledCircle = styled.div<{ $position: 'left' | 'right' }>`
	position: absolute;
	top: 50%;
	${(props) =>
		props.$position === 'left'
			? css`
					left: 8px;
			  `
			: css`
					right: 8px;
			  `}
	transform: translateY(-50%);
	width: 6px;
	height: 6px;
	background-color: #000000;
	border-radius: 6px;
`;

const StyledBgLine = styled.div`
	position: absolute;
	top: 3px;
	width: 1px;
	height: 64px;
`;

const StyledBgLineWhite = styled(StyledBgLine)`
	left: 194px;
	background-color: #ffffff;
`;

const StyledBgLineBlack = styled(StyledBgLine)`
	left: 193px;
	background-color: rgba(0, 0, 0, 0.5);
`;

const StyledLetter = styled(Text)<{ $letter?: string }>`
	width: ${(props) => {
		const letter = props.$letter?.toLowerCase();
		if (letter === 'м' || letter === 'm') return '24px';
		if (letter === 'о' || letter === 'o') return '26px';
		if (letter === 'с' || letter === 'c') return '25px';
		return '21px';
	}};
	font-weight: 500;
	font-size: 32px;
	line-height: 37px;
	padding-top: 5px;
	color: #000000;
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, 0.75),
		2px 2px 0px rgba(0, 0, 0, 0.1);
`;

const StyledDigit = styled(Text)`
	width: 24px;
	font-weight: 500;
	font-size: 40px;
	line-height: 42px;
	text-align: center;
	color: #000000;
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, 0.75),
		2px 2px 0px rgba(0, 0, 0, 0.1);
`;

const StyledNumberContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 17px;
	transform: translateY(-50%);
	display: flex;
	align-items: flex-end;
	justify-content: center;
	width: 170px;
`;

const StyledSpace = styled.div`
	width: 7px;
`;

const StyledCountryContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 5px;

	${Text} {
		font-weight: 300;
		font-size: 14px;
		line-height: 16px;
		color: #000000;
		text-shadow:
			-1px -1px 0px rgba(255, 255, 255, 0.75),
			1px 1px 0px rgba(0, 0, 0, 0.1);
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledRegionContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 10px;
`;

const StyledRegion = styled(Text)`
	width: 36px;
	height: 14px;
	font-weight: 700;
	font-size: 20px;
	line-height: 23px;
	color: #000000;
	text-shadow:
		-1px -1px 0px rgba(255, 255, 255, 0.75),
		1px 1px 0px rgba(0, 0, 0, 0.1);
	text-align: center;
`;

export {
	StyledBgLineBlack,
	StyledBgLineWhite,
	StyledCircle,
	StyledContainer,
	StyledCountryContainer,
	StyledDigit,
	StyledLetter,
	StyledNumberContainer,
	StyledRegion,
	StyledRegionContainer,
	StyledSpace,
	StyledStroke,
};
